import React, { useState, useEffect, useMemo } from 'react';

import { format, subDays, setHours, setMinutes, setSeconds } from 'date-fns';

import { useSelector } from 'react-redux';

import { Report } from '~/components';
import {
  DateTime,
  Autocomplete,
  Input,
  RadioGroup,
  Select,
} from '~/components/Form';
import * as Yup from 'yup';
import { t, parseDateString } from '~/helpers';
import bico from '~/store/modules/bico/reducer';
import { FormatBoldOutlined } from '@material-ui/icons';
import { FRENTISTA, GPP, GPPEM } from '~/constants/perfil';

function Relabastecimentonoposto() {
  const [open, setOpen] = useState(true);
  const [posto, setPosto] = useState(0);
  const [produto, setProduto] = useState(0);
  const [bico, setBico] = useState(0);

  const { profile } = useSelector((state) => state.user);

  //NOVOS CAMPOS
  const [valueOrgao, setValueOrgao] = React.useState(0);
  const [inputValueOrgao, setInputValueOrgao] = React.useState('');

  const [valueUnidade, setValueUnidade] = React.useState(0);
  const [inputValueUnidade, setInputValueUnidade] = React.useState('');

  const [valuePosto, setValuePosto] = React.useState('');
  const [inputValuePosto, setInputValuePosto] = React.useState('');
  const [valuePostoAbrev, setValuePostoAbrev] = React.useState('');
  const [desMunicipio, setDesMunicipio] = React.useState('');

  const [valueProduto, setValueProduto] = React.useState(0);
  const [inputValueProduto, setInputValueProduto] = React.useState('');

  const [disablePosto, setDisablePosto] = useState(false);

  const datahorainicial = useMemo(
    () =>
      format(
        setSeconds(setMinutes(setHours(subDays(new Date(), 7), 0), 0), 0),
        'dd/MM/yyyy HH:mm:ss'
      ),
    []
  );

  const datahorafinal = useMemo(
    () =>
      format(
        setSeconds(setMinutes(setHours(new Date(), 23), 59), 59),
        'dd/MM/yyyy HH:mm:ss'
      ),
    []
  );

  const [postoRequired, setPostoRequired] = useState(true);

  async function handleValidate(param) {
    try {
      if (profile.glousuariotipo != GPPEM) {
        const schema = Yup.object().shape({
          poco_codigo: Yup.string()
            .required(t('s.geral.validacao.campoobrigatorio'))
            .nullable(),
          // datahorainicial: Yup.string().required(t('s.geral.validacao.campoobrigatorio')),
          // datahorafinal: Yup.string().required(t('s.geral.validacao.campoobrigatorio')),
          datahorainicial: Yup.date()
            .typeError(t('s.geral.validacao.campoobrigatorio'))
            .transform((_, value) => parseDateString(value))
            .required(t('s.geral.validacao.campoobrigatorio')),
          datahorafinal: Yup.date()
            .typeError(t('s.geral.validacao.campoobrigatorio'))
            .transform((_, value) => parseDateString(value))
            .required(t('s.geral.validacao.campoobrigatorio'))
            .max(
              datahorafinal,
              `A data não pode ser superior a ${datahorafinal}`
            )
            .min(
              Yup.ref('datahorainicial'),
              'A data não pode ser inferior a Data inicial'
            ),
          veic_placa: Yup.string()
            //.required(t('s.geral.validacao.campoobrigatorio'))         
            .min(0, t('s.geral.validacao.tamanhominimo').replace('%s', 0))
            .max(7, t('s.geral.validacao.tamanhomaximo').replace('%s', 7)),


        });

        await schema.validate(param, {
          abortEarly: false,
        });
      }
    } catch (err) {
      const form = {};

      if (err instanceof Yup.ValidationError) {
        err.inner.forEach((error) => {
          form[error.path] = error.message.replace(`${error.path} `, '');
        });

        throw { form };
      }
    }
  }
  useEffect(() => {
    let mounted = true;
    if (mounted) {
      if (profile.glousuariotipo === GPP) {
        setValuePosto(profile.glousuariopostocodigo);
        setDisablePosto(true);
      } 
      if (profile.glousuariotipo === FRENTISTA) {
        setValuePosto(profile.glousuariopostocodigo);
        setDisablePosto(true);
      } 
      
      /*else if (profile.glousuariotipo === GPPEM) {
        setValuePosto('');
        setDisablePosto(false);
      }*/
    }
    return function cleanup() {
      mounted = false;
    };
  }, [profile]);

  function handleSerializeForm(params) {
    const { datahorainicial, datahorafinal } = params;

    let cod_posto = '';
    let des_posto = '';
    let des_municipio = '';

    if (params.poco_codigo) {
      cod_posto = params.poco_codigo;

      if (params.poco_desc_abrev) {
        des_posto = params.poco_desc_abrev;
      } else {
        des_posto = valuePostoAbrev;
      }

      des_municipio = desMunicipio;

    } else {
      cod_posto = '';
      des_posto = '';
      des_municipio = '';
    }




    let cod_orgao = '';
    if (params.orga_codigo) {
      cod_orgao = params.orga_codigo;
    } else {
      cod_orgao = '';
    }

    let des_orgao = '';
    if (params.orga_nome) {
      des_orgao = params.orga_nome;
    } else {
      des_orgao = '';
    }

    let cod_combustivel = '';
    if (params.prod_codigo) {
      cod_combustivel = params.prod_codigo;
    } else {
      cod_combustivel = '';
    }

    let des_combustivel = '';
    if (params.prod_descricao) {
      des_combustivel = params.prod_descricao;
    } else {
      des_combustivel = '';
    }

    let des_placa = '';
    if (params.veic_placa) {
      des_placa = params.veic_placa;
    } else {
      des_placa = '';
    }

    let tipo = 'pdf';
    if (params.formato) {
      tipo = params.formato;
    } else {
      tipo = 'pdf';
    }

    return {
      ...params,
      cod_posto,
      des_posto,
      des_municipio,
      cod_orgao,
      des_orgao,
      cod_combustivel,
      des_combustivel,
      des_placa,
      tipo,
    };
  }

  return (
    <Report
      open={open}
      onClose={() => setOpen(false)}
      title="Abastecimentos no posto"
      relatorio="abastecimentosnoposto"
      validate={(param) => handleValidate(param)}
      serialize={(param) => handleSerializeForm(param)}
      initials={{
        datahorainicial,
        datahorafinal,
        poco_codigo: valuePosto,
      }}
    >

      {/* <DateTime time label="Data Inicial" name="datahorainicial" />
      <DateTime time label="Data Final" name="datahorafinal" /> */}

      <DateTime
        time
        label="Data Inicial"
        name="datahorainicial"
        disableFuture
      />

      <DateTime
        time
        label="Data Final"
        name="datahorafinal"
        disableFuture
        invalidDateMessage={''}
        minDateMessage={''}
        maxDateMessage={''}
      />

      <Autocomplete
        name="orga_codigo"
        label="orga_nome"
        title="Órgão"
        id="orga_codigo"
        url="orgaos"
        unique="orga_codigo"
        value={valueOrgao}
        inputValue={inputValueOrgao}
        onChange={(event, newValue) => {
          setValueOrgao(newValue);
        }}
        onInputChange={(event, newInputValueOrgao) => {
          setInputValueOrgao(newInputValueOrgao);
        }}
        defaultValue=""
        hiddens={[{ name: 'orga_nome' }]}
        getValue={(value) => {
          setValueUnidade(0);
          setInputValueUnidade('');
          if (value.orga_codigo !== null) {
            setValueOrgao(value.orga_codigo);
          } else {
            setValueOrgao(undefined);
          }
        }}
      />

      <Autocomplete
        name="poco_codigo"
        label="poco_desc_abrev"
        title="Posto"
        id="poco_codigo"
        url="postosporusuario"
        unique="poco_codigo"
        value={valuePosto}
        inputValue={inputValuePosto}
        onChange={(event, newValue) => {
          setValuePosto(newValue);
        }}
        onInputChange={(event, newInputValuePosto) => {
          setInputValuePosto(newInputValuePosto);
        }}
        defaultValue=""
        hiddens={[{ name: 'poco_desc_abrev' }]}
        getValue={(value) => {
          if (value.poco_codigo !== null) {
            setValuePosto(value.poco_codigo);
            setValuePostoAbrev(value.poco_desc_abrev)
            setDesMunicipio(value.muni_nome);
          } else {
            setValuePosto(undefined);
            setValuePostoAbrev('');
            setDesMunicipio('');
          }
        }}
        disabled={disablePosto}
        required="true"
      />

      <Autocomplete
        name="prod_codigo"
        label="prod_descricao"
        title="Produto"
        id="prod_codigo"
        url="produtos"
        unique="prod_codigo"
        value={valueProduto}
        inputValue={inputValueProduto}
        onChange={(event, newValue) => {
          setValueProduto(newValue);
        }}
        onInputChange={(event, newInputValueProtudo) => {
          setInputValueProduto(newInputValueProtudo);
        }}
        defaultValue=""
        hiddens={[{ name: 'prod_descricao' }]}
        getValue={(value) => {
          if (value.prod_codigo !== null) {
            setValueProduto(value.prod_codigo);
          } else {
            setValueProduto(0);
          }
        }}
      />

      <Input name="veic_placa" label="Placa" />

      <RadioGroup
        name="formato"
        label="Formato"
        options={[
          { label: 'PDF', value: 'pdf' },
          { label: 'Excel', value: 'xls' },
        ]}
        defaultValue="pdf"
        serialize={(value) => value}
        row
      />
    </Report>
  );
}

export default Relabastecimentonoposto;
